<template>
<div class="container">
    <div class="row">
        <div id="title" class="col-12">
            <h3>{{ id }} 區間度數</h3>
            <router-link :to="{ name: 'Main', params: { id: this.id }}">回首頁</router-link>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 form-group">
            <label>起始日期:</label>
            <date-picker v-model="start" :config="options"></date-picker>
        </div>
        <div class="col-md-12 form-group">
            <label>截止日期:</label>
            <date-picker v-model="end" :config="options"></date-picker>
        </div>
        <div class="col-md-12 form-group">
            <button type="button" class="btn btn-primary btn-lg btn-block" @click="getData()">顯示</button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">案場</span>
                </div>
                <input type="text" class="form-control" id="project" readonly :value="location" />
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">發電度數</span>
                </div>
                <input type="text" class="form-control" id="kwh" readonly :value="kwh" />
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">平均發電量</span>
                </div>
                <input type="text" class="form-control" id="averge" readonly :value="average" />
            </div>
            <div class="form-group">
                <label for>訊息</label>
                <textarea class="form-control" name id="message" rows="3" readonly v-model="message"></textarea>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// Import this component
import datePicker from "vue-bootstrap-datetimepicker";
// import moment js
import moment from "moment";

export default {
    name: "Interval",
    components: {
        datePicker
    },
    data() {
        return {
            id: "",
            start: moment()
                .subtract(2, "months")
                .format("YYYY-MM-DD"),
            end: moment().format("YYYY-MM-DD"),
            options: {
                format: "YYYY-MM-DD",
                useCurrent: false
            },
            location: "",
            kwh: "",
            average: "",
            watt: "",
            message: ""
        };
    },
    created() {
        this.id = this.$route.params.id.toUpperCase();
    },
    methods: {
        getData() {
            this.$http
                .get(process.env.VUE_APP_SOALR_URL + `/api/solar/infos/${this.id}`)
                .then(res => {
                    const data = res.data.info;
                    this.location =
                        this.id +
                        "-" +
                        data["location"] +
                        data["name"] +
                        "-" +
                        data["total_watt"] +
                        "kw";
                    this.watt = data["total_watt"];
                });

            this.$http
                .post(process.env.VUE_APP_SOALR_URL + `/api/solar/interval`, {
                    pid: this.id,
                    start: this.start,
                    end: this.end
                })
                .then(res => {
                    const data = res.data;
                    this.kwh = data.kwh;
                    this.average =
                        Math.round((data.kwh / data.days / this.watt) * 100) / 100;
                    this.message = data.msg.replace(",", "\n");
                });
        }
    }
};

// import icons
$.extend(true, $.fn.datetimepicker.defaults, {
    icons: {
        time: "far fa-clock",
        date: "far fa-calendar",
        up: "fas fa-arrow-up",
        down: "fas fa-arrow-down",
        previous: "fas fa-chevron-left",
        next: "fas fa-chevron-right",
        today: "fas fa-calendar-check",
        clear: "far fa-trash-alt",
        close: "far fa-times-circle"
    }
});
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/bootstrap";
@import "~pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
@import "~@fortawesome/fontawesome-free/css/all.css";

#title {
    margin: 20px auto;
    text-align: center;
}
</style>
